import { render } from "./HospitalApplication.vue?vue&type=template&id=0d765588&ts=true"
import script from "./HospitalApplication.vue?vue&type=script&lang=ts"
export * from "./HospitalApplication.vue?vue&type=script&lang=ts"

import "./HospitalApplication.vue?vue&type=style&index=0&id=0d765588&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__